(()=>{
  const key='__glowScrollHintCleanup';
  window[key]?.();
  const selector='variant-selects .ig-color-options-scroll';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width: 749px)');
  const tracked=new WeakSet(),cleanups=new Set(),seen=new Set();
  let stopped=false,lastScroll=performance.now();
  const onScroll=()=>{lastScroll=performance.now();};
  window.addEventListener('scroll',onScroll,{passive:true});
  const remember=kind=>seen.add(kind);
  const wasSeen=kind=>seen.has(kind);
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){
      if(!entry.isIntersecting||entry.intersectionRatio<.7)continue;
      const rail=entry.target,kind=rail.matches('.gh-clothing-grid')?'clothes':'colors';
      if(!mobile.matches||reduced.matches||wasSeen(kind)||rail.scrollWidth<=rail.clientWidth+8||rail.scrollLeft>3)continue;
      observer.unobserve(rail);
      rail.dataset.glowHintPending='true';
      let timer=0,done=false,animations=[];
      const stop=()=>{
        if(done)return;done=true;clearTimeout(timer);
        delete rail.dataset.glowHintPending;
        animations.forEach(animation=>animation.cancel());
        for(const type of ['pointerdown','touchstart','wheel','keydown'])rail.removeEventListener(type,interact);
        window.removeEventListener('scroll',cancelMoving);
        cleanups.delete(stop);
      };
      const interact=()=>{remember(kind);stop();};
      const cancelMoving=()=>{if(animations.length)stop();};
      cleanups.add(stop);
      for(const type of ['pointerdown','touchstart','wheel','keydown'])rail.addEventListener(type,interact,{passive:true});
      window.addEventListener('scroll',cancelMoving,{passive:true});
      const begin=()=>{
        if(done)return;
        if(!rail.isConnected||document.hidden||!mobile.matches||reduced.matches||rail.scrollLeft>3){stop();return;}
        const bounds=rail.getBoundingClientRect();
        const visible=Math.max(0,Math.min(bounds.bottom,innerHeight)-Math.max(bounds.top,0));
        if(visible<bounds.height*.7){timer=setTimeout(begin,200);return;}
        if(performance.now()-lastScroll<300){timer=setTimeout(begin,180);return;}
        const items=[...rail.children].filter(item=>item.matches('.gh-garment,label'));
        if(!items.length||typeof items[0].animate!=='function'){stop();return;}
        remember(kind);
        const distance=Math.min(22,rail.scrollWidth-rail.clientWidth);
        animations=items.map(item=>item.animate([
          {translate:'0px 0px',offset:0},
          {translate:-distance+'px 0px',offset:.5},
          {translate:'0px 0px',offset:1}
        ],{duration:1400,easing:'ease-in-out',iterations:1}));
        Promise.all(animations.map(animation=>animation.finished.catch(()=>{}))).then(stop);
      };
      timer=setTimeout(begin,500);
    }
  },{threshold:[.7]});
  const resizeObserver=new ResizeObserver(entries=>{
    for(const {target:rail} of entries){
      const kind=rail.matches('.gh-clothing-grid')?'clothes':'colors';
      if(!wasSeen(kind)&&!rail.dataset.glowHintPending){observer.unobserve(rail);observer.observe(rail);}
    }
  });
  const scan=()=>{
    if(stopped)return;
    document.querySelectorAll(selector).forEach(rail=>{
      if(tracked.has(rail))return;
      tracked.add(rail);observer.observe(rail);resizeObserver.observe(rail);
    });
  };
  let scanFrame=0;
  const mutations=new MutationObserver(()=>{
    if(!scanFrame)scanFrame=requestAnimationFrame(()=>{scanFrame=0;scan();});
  });
  mutations.observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  scan();
  window[key]=()=>{
    stopped=true;observer.disconnect();resizeObserver.disconnect();mutations.disconnect();cancelAnimationFrame(scanFrame);
    window.removeEventListener('scroll',onScroll);
    for(const stop of [...cleanups])stop();
  };
})();